import Vue from 'vue'
import Vuex from 'vuex'
import { detectOS } from '@/utils/utils'

import user from './modules/user'
import classManage from './modules/classManage'
import studentManage from './modules/studentManage'
import base from './modules/base'
import teacherManage from './modules/teacherManage'
import workManage from './modules/workManage'
import myWork from './modules/myWork'
import courseManage from './modules/courseManage'
import intro from './modules/intro'
import dataGraph from './modules/dataGraph'
import unitManage from './modules/unitManage'
import learningStatistics from './modules/learningStatistics'

import getters from './getters'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

/**
 * 设置对象的响应式属性.如obj不存在传递进来的属性,则设置属性,否则更新值.支持多层嵌套
 * @param obj {object} 目标对象
 * @param keyString {string} 形如'key.key.key'的字符串
 * @param val {*} 需要设置的值
 */
const setRespondValByKey = function(obj, keyString, val) {
  let current = obj
  const keyArray = keyString.split('.') // 分解key,将字符串转换为数组
  const len = keyArray.length

  if (len > 0) {
    keyArray.forEach((key, index) => {
      if (typeof current[key] === 'undefined') {
        // 如果属性不存在
        if (index < len - 1) {
          // 如果不为最后一个属性,则设置为空对象
          Vue.set(current, key, {})
        } else {
          // 否则,设置值
          Vue.set(current, key, val)
        }
      } else if (index + 1 === len) {
        // 如果原来的对象已经定义,在最后一个属性设置值
        current[key] = val
      }
      current = current[key]
    })
  }
}

// 创建 store 实例
export default new Vuex.Store({
  modules: {
    user,
    classManage,
    studentManage,
    base,
    teacherManage,
    workManage,
    myWork,
    courseManage,
    intro,
    dataGraph,
    unitManage,
    learningStatistics
  },
  state: {
    locale: 'en',
    locales: ['zh-CN', 'zh-TW', 'en', 'it', 'id'],
    token: localStorage.getItem('token'),
    userInfo: null,
    userCenterShow: false,
    serviceWorkerUpdated: false,
    os: detectOS()
  },
  getters,
  mutations: {
    /**
     * 更新对应模块下对应键的值
     * @param state
     * @param module {string} 模块名
     * @param key {string} 对应的键
     * @param value 需要更新的值
     */
    setState(state, { module, key, value }) {
      setRespondValByKey(state[module], key, value)
    },
    SET_LANG(state, locale) {
      if (state.locales.indexOf(locale) !== -1) {
        state.locale = locale
      }
    },
    LOGIN(state, { token }) {
      localStorage.setItem('token', token)
      state.token = token
    },
    LOGOUT(state) {
      localStorage.removeItem('has_password')
      localStorage.removeItem('role_id')
      localStorage.removeItem('token')
      state.token = state.userInfo = null
    },
    SERVICEWORKERUPDATED(state) {
      state.serviceWorkerUpdated = true
    },
    SETUSERINFO(state, data) {
      state.userInfo = data
    },
    USERCENTERSHOW(state, boolean) {
      state.userCenterShow = boolean
    }
  },
  actions: {
    async getUserInfo(
      {
        commit,
        state: { userInfo }
      },
      { cache = true } = {}
    ) {
      if (cache && userInfo) return userInfo
      const { status, data } = await window.API.get('/edu/zone/user')
      if (status < 400) {
        commit('SETUSERINFO', data)
        return data
      }
    }
  },
  strict: debug
})
